import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';
import { MenuButton } from '../components/NavigationMenu';

const PoliticaCookiesPage = () => {
  return (
    <div className="min-h-screen bg-[#1a2b3c] text-[#f5f5dc]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#1a2b3c]/95 backdrop-blur-sm border-b border-[#50c878]/20">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-3">
            <MenuButton />
            <Link 
              to="/" 
              className="flex items-center gap-2 text-[#f5f5dc]/60 hover:text-[#f5f5dc] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm hidden sm:inline">Volver</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pt-20 pb-12 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 rounded-full bg-[#50c878]/20 flex items-center justify-center">
            <Cookie className="w-6 h-6 text-[#50c878]" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-cinzel text-[#f5f5dc]">Política de Cookies</h1>
        </div>

        <div className="prose prose-invert max-w-none space-y-6">
          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">1. ¿Qué son las Cookies?</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Una cookie es un fichero que se descarga en su ordenador o dispositivo al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">2. ¿Qué Tipos de Cookies Utiliza esta Página Web?</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              www.amagnificentlife.es utiliza las siguientes tipologías de cookies:
            </p>
            
            <div className="space-y-4">
              <div className="p-4 bg-[#1a2b3c] rounded-lg">
                <h3 className="text-[#f5f5dc] font-medium mb-2">Cookies técnicas</h3>
                <p className="text-[#f5f5dc]/70 text-sm leading-relaxed">
                  Son aquellas que permiten al usuario la navegación a través de la página web y la utilización de las diferentes opciones o servicios que en ella existen, como controlar el tráfico y la comunicación de datos, identificar la sesión o acceder a partes de acceso restringido.
                </p>
              </div>

              <div className="p-4 bg-[#1a2b3c] rounded-lg">
                <h3 className="text-[#f5f5dc] font-medium mb-2">Cookies de personalización</h3>
                <p className="text-[#f5f5dc]/70 text-sm leading-relaxed">
                  Permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario (ej. el idioma).
                </p>
              </div>

              <div className="p-4 bg-[#1a2b3c] rounded-lg">
                <h3 className="text-[#f5f5dc] font-medium mb-2">Cookies de análisis</h3>
                <p className="text-[#f5f5dc]/70 text-sm leading-relaxed">
                  Son aquellas que, tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello se analiza su navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que le ofrecemos.
                </p>
              </div>

              <div className="p-4 bg-[#1a2b3c] rounded-lg">
                <h3 className="text-[#f5f5dc] font-medium mb-2">Cookies de terceros</h3>
                <p className="text-[#f5f5dc]/70 text-sm leading-relaxed">
                  Esta web puede utilizar servicios de terceros (como Google Analytics) que recopilarán información con fines estadísticos y de uso del sitio por parte del usuario.
                </p>
              </div>
            </div>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">3. Detalle de Cookies Utilizadas</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              A continuación, se detallan las cookies utilizadas en este portal:
            </p>
            
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[#50c878]/30">
                    <th className="text-left py-3 px-2 text-[#f5f5dc]">Nombre</th>
                    <th className="text-left py-3 px-2 text-[#f5f5dc]">Proveedor</th>
                    <th className="text-left py-3 px-2 text-[#f5f5dc]">Finalidad</th>
                    <th className="text-left py-3 px-2 text-[#f5f5dc]">Duración</th>
                  </tr>
                </thead>
                <tbody className="text-[#f5f5dc]/70">
                  <tr className="border-b border-[#50c878]/10">
                    <td className="py-3 px-2 font-mono text-[#50c878]">_ga</td>
                    <td className="py-3 px-2">Google Analytics</td>
                    <td className="py-3 px-2">Registro de visitas únicas con fines estadísticos</td>
                    <td className="py-3 px-2">2 años</td>
                  </tr>
                  <tr className="border-b border-[#50c878]/10">
                    <td className="py-3 px-2 font-mono text-[#50c878]">_gid</td>
                    <td className="py-3 px-2">Google Analytics</td>
                    <td className="py-3 px-2">Agrupación del comportamiento del usuario</td>
                    <td className="py-3 px-2">24 horas</td>
                  </tr>
                  <tr className="border-b border-[#50c878]/10">
                    <td className="py-3 px-2 font-mono text-[#50c878]">session_id</td>
                    <td className="py-3 px-2">Propia</td>
                    <td className="py-3 px-2">Mantener la sesión del usuario abierta (técnica)</td>
                    <td className="py-3 px-2">Sesión</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-2 font-mono text-[#50c878]">cookie_notice</td>
                    <td className="py-3 px-2">Propia</td>
                    <td className="py-3 px-2">Recordar si el usuario aceptó la política de cookies</td>
                    <td className="py-3 px-2">1 año</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">4. Consentimiento y Configuración</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              El usuario puede aceptar, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador.
            </p>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Al navegar por primera vez por nuestra web, aparecerá un panel donde podrá elegir qué cookies desea instalar. En cualquier momento puede volver a cambiar su configuración desde el enlace de "Configuración de Cookies" situado en el pie de página.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">5. Cómo Desactivar las Cookies en los Principales Navegadores</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador:
            </p>
            <ul className="space-y-2 text-[#f5f5dc]/70">
              <li><strong className="text-[#f5f5dc]">Google Chrome:</strong> Configuración → Privacidad y seguridad → Cookies y otros datos de sitios.</li>
              <li><strong className="text-[#f5f5dc]">Mozilla Firefox:</strong> Ajustes → Privacidad y Seguridad → Cookies y datos del sitio.</li>
              <li><strong className="text-[#f5f5dc]">Safari:</strong> Preferencias → Privacidad → Bloquear todas las cookies.</li>
              <li><strong className="text-[#f5f5dc]">Microsoft Edge:</strong> Configuración → Cookies y permisos del sitio.</li>
            </ul>
            <p className="text-[#f5f5dc]/60 text-sm mt-4">
              Si opta por bloquear las cookies en su navegador, es posible que algunos servicios o funcionalidades de la página web no estén disponibles.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">6. Actualizaciones y Cambios en la Política de Cookies</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Versión Digital S.L. puede modificar esta Política de Cookies en función de nuevas exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos.
            </p>
          </section>

          <section className="bg-[#50c878]/10 rounded-xl p-6 border border-[#50c878]/30">
            <h2 className="text-lg font-semibold text-[#f5f5dc] mb-3">Nota Importante</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed text-sm">
              Las cookies de Google Analytics (o similares) no se cargan hasta que el usuario pulse "Aceptar" en el banner de cookies. Este enlace a la "Política de Cookies" está disponible permanentemente en el footer de la web junto al Aviso Legal y la Política de Privacidad.
            </p>
          </section>
        </div>

        <p className="mt-8 text-[#f5f5dc]/40 text-sm text-center">
          Última actualización: Marzo 2026
        </p>
      </main>
    </div>
  );
};

export default PoliticaCookiesPage;
